import React, { Component } from "react";
import _ from "lodash";
import { withRedux } from "../hoc";

const mapStateToProps = state => {
  return {
    t: _.get(state, "t"),
    languages: _.get(state, "languages")
  };
};

const actions = {};

@withRedux(mapStateToProps, actions)
export default class SliderArrow extends Component {
  PrevArrow = props => {
    const { className, onClick, t } = props;
    return (
      <div className={className} onClick={onClick}>
        {`< ${t("Back")}`}
      </div>
    );
  };
  NextArrow = props => {
    const { className, onClick, t } = props;
    return (
      <div className={className} onClick={onClick}>
        {`${t("Next")} >`}
      </div>
    );
  };
  render() {
    const { type } = this.props;
    if (type === "prev") return this.PrevArrow();
    if (type === "next") return this.NextArrow();
  }
}



// WEBPACK FOOTER //
// ./src/components/SliderArrow.js